document.addEventListener('DOMContentLoaded', function() {
  const containersDiv = document.getElementById('containers');
  const addContainerButton = document.getElementById('add-container');
  
  if (!containersDiv || !addContainerButton) return;
  
  // Function to update container indices
  function updateContainerIndices() {
    const containerFields = containersDiv.querySelectorAll('.container-fields');
    containerFields.forEach((container, index) => {
      container.dataset.containerIndex = index;
      
      // Update all input names and IDs
      container.querySelectorAll('input, select').forEach(input => {
        const name = input.name;
        if (name) {
          input.name = name.replace(/containers\[\d+\]/, `containers[${index}]`);
        }
        
        const id = input.id;
        if (id) {
          input.id = id.replace(/containers_\d+_/, `containers_${index}_`);
        }
      });
      
      // Update labels
      container.querySelectorAll('label').forEach(label => {
        const forAttr = label.getAttribute('for');
        if (forAttr) {
          label.setAttribute('for', forAttr.replace(/containers_\d+_/, `containers_${index}_`));
        }
      });
      
      // Update container number in header
      const boxTitle = container.querySelector('.Box-title');
      if (boxTitle) {
        boxTitle.textContent = `Container ${index + 1}`;
      }
    });
  }
  
  // Add container button click handler
  addContainerButton.addEventListener('click', function(e) {
    e.preventDefault();
    
    const containerCount = containersDiv.querySelectorAll('.container-fields').length;
    const newIndex = containerCount;
    
    // Create a new container fields element
    const template = `
      <div class="container-fields" data-container-index="${newIndex}">
        <div class="Box mb-3">
          <div class="Box-header">
            <h4 class="Box-title">Container ${newIndex + 1}</h4>
            <div class="Box-header-actions">
              <a href="#" class="btn btn-sm btn-danger remove-container" data-index="${newIndex}">Remove</a>
            </div>
          </div>
          <div class="Box-body">
            <div class="form-group">
              <label for="shipping_instruction_containers_${newIndex}_container_number" class="form-label">Container Number</label>
              <input type="text" name="shipping_instruction[containers][${newIndex}][container_number]" 
                     id="shipping_instruction_containers_${newIndex}_container_number" 
                     class="form-control" placeholder="e.g., MSKU1234567">
            </div>
            
            <div class="form-group">
              <label for="shipping_instruction_containers_${newIndex}_seal_number" class="form-label">Seal Number</label>
              <input type="text" name="shipping_instruction[containers][${newIndex}][seal_number]" 
                     id="shipping_instruction_containers_${newIndex}_seal_number" 
                     class="form-control" placeholder="e.g., SEAL123456">
            </div>
            
            <div class="form-group">
              <label for="shipping_instruction_containers_${newIndex}_container_type" class="form-label">Container Type</label>
              <select name="shipping_instruction[containers][${newIndex}][container_type]" 
                      id="shipping_instruction_containers_${newIndex}_container_type" 
                      class="form-select">
                <option value="20GP">20' Standard</option>
                <option value="40GP">40' Standard</option>
                <option value="40HC" selected>40' High Cube</option>
                <option value="45HC">45' High Cube</option>
                <option value="20RE">20' Reefer</option>
                <option value="40RE">40' Reefer</option>
              </select>
            </div>
            
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="shipping_instruction_containers_${newIndex}_weight" class="form-label">Weight</label>
                  <input type="number" name="shipping_instruction[containers][${newIndex}][weight]" 
                         id="shipping_instruction_containers_${newIndex}_weight" 
                         class="form-control" placeholder="e.g., 24750">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="shipping_instruction_containers_${newIndex}_weight_unit" class="form-label">Weight Unit</label>
                  <select name="shipping_instruction[containers][${newIndex}][weight_unit]" 
                          id="shipping_instruction_containers_${newIndex}_weight_unit" 
                          class="form-select">
                    <option value="lb" selected>Pounds</option>
                    <option value="kg">Kilograms</option>
                  </select>
                </div>
              </div>
            </div>
            
            <div class="form-group">
              <label for="shipping_instruction_containers_${newIndex}_description" class="form-label">Description</label>
              <input type="text" name="shipping_instruction[containers][${newIndex}][description]" 
                     id="shipping_instruction_containers_${newIndex}_description" 
                     class="form-control" value="RESIN NON HAZ" placeholder="e.g., RESIN NON HAZ">
            </div>
          </div>
        </div>
      </div>
    `;
    
    containersDiv.insertAdjacentHTML('beforeend', template);
    attachRemoveHandlers();
  });
  
  // Function to attach remove handlers
  function attachRemoveHandlers() {
    document.querySelectorAll('.remove-container').forEach(button => {
      button.removeEventListener('click', removeContainer);
      button.addEventListener('click', removeContainer);
    });
  }
  
  // Remove container handler
  function removeContainer(e) {
    e.preventDefault();
    
    const containerFields = e.target.closest('.container-fields');
    if (containerFields) {
      containerFields.remove();
      updateContainerIndices();
    }
  }
  
  // Initial attachment of remove handlers
  attachRemoveHandlers();
});